import {
    LucideIcon,
    LucideShoppingCart,
    LucideScale,
    LucideGem,
    LucideDownloadCloud,
    LucideFileType2, Disc
} from 'lucide-react';

import {Typography} from "../ui/Typography";
import {BaseModal, ModalCloseButton} from "./ModalBase";
import React from "react";
import {Button} from "../ui/Button";
import {RoundBadge} from "../common/RoundBadge";
import {IconData, IconPackData} from "../../data/icons";

interface IconPackModalProps {
    iconPackData: IconPackData;
    isOpen: boolean;
    onClose: () => void;
}

export const IconPackModal2 = ({iconPackData, isOpen, onClose}: IconPackModalProps) => (
    <BaseModal
        isOpen={isOpen}
        onClose={onClose}
        containerClassName="relative w-full max-w-[960px] rounded-2xl shadow-2xl z-50 mx-auto my-8 p-6 md:p-8 flex flex-col gap-6"
    >
        <div className="flex flex-col w-full">
            
            <ModalCloseButton onClose={onClose}/>

            <main className="grid grid-cols-1 md:grid-cols-12 md:gap-x-8 gap-y-8">
                <ColumnLeft iconPackData={iconPackData} />
                <ColumnRight iconPackData={iconPackData} />
            </main>

        </div>
    </BaseModal>
); 


const Header = ({iconPackName} : any) => {
return (
    <div className="flex justify-between items-center pb-4 border-surface-200">
            <Typography as="h2" variant="h2">
                {iconPackName}
            </Typography>
        </div>
    );
};


// getIconThumbnail

const ColumnRight = ({ iconPackData }: { iconPackData: IconPackData }) => {
    const discountPercentage = 50;
    function calcDiscountedPrice(amount, discountPercentage) {
        return Math.round(amount * (discountPercentage / 100));
    }

    return (
        <div className="md:col-span-5 flex flex-col">
            <div className="flex-grow space-y-6">
                <div>
                    <Header iconPackName={iconPackData.name} />
                    <RoundBadge
                        amount={23}
                        className="flex items-center justify-center text-xl px-4 py-3 rounded-full w-1/3"
                    />
                </div>

                <ul className="space-y-3 text-surface-700">
                    <UniqueFeature text="SVG & PNG file formats" lucideIcon={LucideFileType2} />
                    {/*<UniqueFeature text="Various resolutions (128px, 256px, 512px)" lucideIcon={LucideMaximize} />*/}
                    <UniqueFeature text="Commercial/ Personal use" lucideIcon={LucideScale} />
                    <UniqueFeature text="Lifetime access" lucideIcon={LucideDownloadCloud} />
                </ul>
            </div>

            <div className="space-y-6"> 
                <div className="relative">
                    <div className="flex items-baseline gap-3">
                        <Typography
                            as="h2"
                            variant="h1"
                            className="flex items-center gap-2"
                        >
                            <LucideGem className="mr-2 text-brand-500 text-surface-100 w-10 h-10" />
                            {calcDiscountedPrice(iconPackData.price, discountPercentage)}

                            <span className="text-xl font-normal text-surface-400 line-through ml-2">
                                {iconPackData.price} credits
                            </span>
                        </Typography>

                        <Labelke />
                    </div>
                </div>

                <Button intent="primary" size="large" glow={true} hover={true}>
                    <LucideShoppingCart className="mr-5" />Add Pack to Cart
                </Button>
            </div>
        </div>
    );
};
const ColumnLeft = ({iconPackData} : {iconPackData : IconPackData}) => {
    return (
        <div className="md:col-span-7">
            <div 
                id="icon-grid-container"
                className="icon-grid-bg bg-surface-950 custom-scrollbar relative min-h-[90%] h-[100%] overflow-y-auto rounded-lg p-6 border 
                border-surface-950/20 shadow-[inset_0px_2px_8px_rgba(0,0,0,0.5)] transition-shadow duration-300">
                
                <div className="grid grid-cols-4 sm:grid-cols-5 md:grid-cols-4 lg:grid-cols-5 gap-4">
                    
                    {iconPackData.icons.map(pack => (<IconImage key={pack.name} data={pack} />))}
                    
                </div>
            </div>
        </div>
    );
};

const IconImage = ({ data }) => {
    const icon = data as IconData;
    return (
        <img
            src={icon.previewImage}
            alt={icon.name}
            className="w-12 h-12"
        />
    );
};

interface UniqueFeatureProps {
    text: string;
    lucideIcon: LucideIcon;
}

const UniqueFeature = (props: UniqueFeatureProps) => {
    const Icon = props.lucideIcon;
    return (
        <li className="inline-flex items-center gap-3 bg-surface-800 text-surface-200 px-4 py-3 rounded-full">
            <Icon className="w-6 text-brand-600"/>
            <Typography as="p" variant="p" className="text-surface-200 text-sm font-medium">{props.text}</Typography>
        </li>
    );
};

const Labelke = () => {
    return (
        <div
            className="cutout-badge absolute top-22 -right-3 -rotate-[5deg] bg-[#ffadc1]
            text-[#72001a] font-bold px-5 py-1.5 rounded-md text-sm shadow-lg"
        >
            50% OFF
        </div>
    );
};











